<h1>Counter value: {{ value() }}</h1>
